export const CHANNEL_NAMES = ["input", "sync", "control"];
export class BaseTransport {
    _state = "connecting";
    #channelHandlers = new Map();
    #stateHandlers = new Set();
    get state() {
        return this._state;
    }
    on(channel, cb) {
        let set = this.#channelHandlers.get(channel);
        if (!set) {
            set = new Set();
            this.#channelHandlers.set(channel, set);
        }
        set.add(cb);
        return () => set.delete(cb);
    }
    onStateChange(cb) {
        this.#stateHandlers.add(cb);
        cb(this._state);
        return () => this.#stateHandlers.delete(cb);
    }
    setState(next) {
        if (this._state === next)
            return;
        this._state = next;
        for (const cb of this.#stateHandlers)
            cb(next);
    }
    dispatch(channel, data) {
        for (const cb of this.#channelHandlers.get(channel) ?? [])
            cb(data);
        for (const cb of this.#channelHandlers.get("*") ?? [])
            cb(data);
    }
    close() {
        this.setState("closed");
    }
}
//# sourceMappingURL=transport.js.map